import React from 'react';

const UnderConstruction: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="relative w-[200px] h-[200px] group">
        <div 
          className="absolute inset-0 bg-gradient-to-r from-custom-teal via-custom-purple to-custom-dark-purple transition-all duration-300 ease-in-out group-hover:bg-gradient-custom-hover"
          style={{
            clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)'
          }}
        />
        <div className="absolute inset-0 flex items-center justify-center text-white text-7xl font-bold" style={{ marginTop: '10px' }}>
          !
        </div>
      </div>
      <h1 className="text-3xl font-bold mt-8 text-custom-purple">Under Construction</h1>
    </div>
  );
};

export default UnderConstruction;

